import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { auth as authApi, account } from "../../api/endpoints";
import { useAuth } from "../../auth/AuthContext.jsx";

export default function Account() {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  async function onExport() {
    const r = await account.export();
    const blob = new Blob([JSON.stringify(r.data, null, 2)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "seogeeks-export.json";
    a.click();
    URL.revokeObjectURL(url);
  }

  async function onDelete() {
    if (!confirm(t("account.deleteConfirm"))) return;
    setBusy(true);
    setError(null);
    try {
      await authApi.deleteAccount(pwd);
      logout();
      navigate("/login");
    } catch (err) {
      setError(err?.response?.data?.detail || t("account.couldNotDelete"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="space-y-8 max-w-2xl">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">
          {t("account.title")}
        </h1>
      </div>

      <section className="card space-y-3">
        <h2 className="text-sm font-semibold text-slate-700">
          {t("account.retentionTitle")}
        </h2>
        <p className="text-sm text-slate-600">{t("account.retentionBody")}</p>
        <button onClick={onExport} className="btn-ghost">
          {t("account.exportButton")}
        </button>
      </section>

      <section className="card space-y-3 border-red-200">
        <h2 className="text-sm font-semibold text-red-700">
          {t("account.deleteTitle")}
        </h2>
        <p className="text-sm text-slate-600">{t("account.deleteBody")}</p>
        <input
          type="password"
          className="input"
          placeholder={t("account.confirmPassword")}
          value={pwd}
          onChange={(e) => setPwd(e.target.value)}
        />
        {error && <div className="text-sm text-red-600">{error}</div>}
        <button
          onClick={onDelete}
          className="btn-danger"
          disabled={busy || !pwd}
        >
          {busy ? t("account.deleteBusy") : t("account.deleteButton")}
        </button>
      </section>
    </div>
  );
}
